import React from 'react'
import Login from './Login'
import Nav from './Nav'
export default function About() {
  return (
    <div>
    <Nav></Nav>
    {/* <img tyle={{
          marginTop:"120px",
         }}  url="'https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg"></img> */}
     {/* <Sliding></Sliding> */}
     {/* <div className='row'>
         <div style={{
          marginTop:"70px",
         }} className='row-posters'>

        
           <img style={{
            width:"1000px",
            height:"600px"
           }}
           className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           {/* <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img>
           <img className='row-poster' src='https://assets.indiadesire.com/images/fashion%20haul%20myntra.jpg'></img> */}
           {/* </div>
         </div> */}
    
      <Login></Login>
    </div>
  )
}
